import { createFeatureSelector, createSelector } from '@ngrx/store';

import { State } from '@ren/features/review/state/reducers';
import { ReviewState } from '@ren/features/review/state/reducers/review.reducer';

import { REVIEW_STORE_KEY } from '@ren/infrastructure/constants';


const reviewStore = createFeatureSelector<State>(REVIEW_STORE_KEY);
const reviewState = createSelector(reviewStore, state => state.reviewState);

export const selectYourQuoteSummary = createSelector(
  reviewState,
  (state: ReviewState) => state.yourQuoteSummary
);

export const selectYourCarSummary = createSelector(
  reviewState,
  (state: ReviewState) => state.yourCarSummary
);

export const selectYourDetailsSummary = createSelector(
  reviewState,
  (state: ReviewState) => state.yourDetailsSummary
);

export const selectYourCoverSummary = createSelector(
  reviewState,
  (state: ReviewState) => state.yourCoverSummary
);

export const selectYourDrivingHistorySummary = createSelector(
  reviewState,
  (state: ReviewState) => state.yourDrivingHistorySummary
);

export const selectYourDiscountsSummary = createSelector(
  reviewState,
  (state: ReviewState) => state.yourDiscountsSummary
);

export const selectYourPaymentsSummary = createSelector(
  reviewState,
  (state: ReviewState) => state.yourPaymentsSummary
);

export const selectYourAdditionalDriversSummary = createSelector(
  reviewState,
  (state: ReviewState) => state.yourAdditionalDriversSummary
);

export const selectBookletCodes = createSelector(
  reviewState,
  (state: ReviewState) => state.bookletCodes
);

export const selectPaymentOptions = createSelector(
  reviewState,
  (state: ReviewState) => state.paymentOptions
);
